import { ConnectorValidationModel } from "./ConnectorValidationModel";
import { PluginValidationModel } from "./PluginValidationModel";

export class FabricDiagramValidationConfig {
    connectors = {};

    content = {};

    overall = [];

    constructor(plugins, connectors, overall) {
        if (plugins) {
            Object.keys(plugins).forEach(key => {
                this.addPluginValidationModel(key, plugins[key]);
            });
        }
        if (overall) {
            this.overall.push(...overall);
        }
        this.connectors = new ConnectorValidationModel(connectors);
    }

    setFullConfig(config) {
        this.connectors = config.connectors;
        this.content = config.content;
        this.overall = config.overall;
    }

    addPluginValidationModel(id, config) {
        this.content[id] = new PluginValidationModel(config);
    }

    removePluginValidation(id) {
        delete this.content[id];
    }

    getContentValidations() {
        return this.content;
    }

    getOverallValidations() {
        return this.overall;
    }

    getConnectorsValidations() {
        return this.connectors.forbiddenConnections;
    }
}
